import { render, staticRenderFns } from "./PrimaryArticle.vue?vue&type=template&id=789be63a&scoped=true"
import script from "./PrimaryArticle.vue?vue&type=script&lang=js"
export * from "./PrimaryArticle.vue?vue&type=script&lang=js"
import style0 from "./PrimaryArticle.vue?vue&type=style&index=0&id=789be63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789be63a",
  null
  
)

export default component.exports